import { IResourceComponentsProps, useExport, useList, useShow } from '@pankod/refine-core'

import {
  List,
  RefreshButton,
  CreateButton,
  ExportButton,
  Table,
  Space,
  EditButton,
  DeleteButton,
  DateField,
  getDefaultSortOrder,
  useModalForm,
  Icons,
  Tag,
  Input,
  Divider,
  Button,
  useTable,
  Form
} from '@pankod/refine-antd'
// import { useTable } from '@pankod/refine-core'

import { IDifficultyLevel } from 'interfaces'
import { CreateDifficultyLevel } from './create'
import { EditDifficultyLevel } from './edit'
import { useState } from 'react'
import { exportToExcel } from 'exportToExcel'
const { PlusOutlined } = Icons

export const DifficultyLevelList: React.FC<IResourceComponentsProps> = () => {
  const [pagination,setHasPagination]=useState<any>(true)
  const metaData = {
    fields: ['id', 'name', 'order', 'created_at'],
  }
  //   const { data: testTrackListData } = useList({ resource: 'test_tracks', metaData: { fields: ['id', 'grade_ids'] } })
  const { sorter, tableQueryResult,setFilters ,tableProps,searchFormProps} = useTable<IDifficultyLevel>({
    hasPagination:pagination,
    initialSorter: [
      {
        field: 'created_at',
        order: 'desc',
      },
    ],
    metaData,
    onSearch: (values:any) => {
      return [
          {
              field: "name",
              operator: "contains",
              value:`%${values.title}%`,
          },
      ];
  },
  })
  const { tableQueryResult :exportData} = useTable<IDifficultyLevel>({
    hasPagination:false,
    initialSorter: [
      {
        field: 'created_at',
        order: 'desc',
      },
    ],
    metaData,
  })
  const { formProps, modalProps, show } = useModalForm({
    resource: 'difficulty_levels',
    action: 'create',
  })
  const {
    formProps: editFormProps,
    modalProps: editModalProps,
    show: editShow,
  } = useModalForm({
    resource: 'difficulty_levels',
    action: 'edit',
    metaData,
  })
  const triggerExport=()=>{
    exportToExcel(exportData?.data?.data,`DifficultyLevels_${Math.round(new Date().getTime() / 1000)}.xlsx`)
  }
  //   const hideDeleteButton = (record: IGrade): boolean => {
  //     const { work_requests_ids: wrIds, questions_ids: qIds } = record
  //     if (wrIds !== undefined && qIds !== undefined) {
  //       const shouldHide = wrIds.length > 0 || qIds.length > 0
  //       return shouldHide
  //     }
  //     if (testTrackListData?.data !== undefined) {
  //       let shouldHide = false
  //       testTrackListData.data.map(eachTestTrack => {
  //         eachTestTrack.grade_ids.map((gradeId: string) => {
  //           if (record.id === gradeId) {
  //             shouldHide = true
  //           }
  //         })
  //       })
  //       return shouldHide
  //     }
  //     return false
  //   }
  const { queryResult, setShowId } = useShow<IDifficultyLevel>({
    resource: 'difficulty_levels',
    metaData: metaData,
  })

  const { data: showQueryResult } = queryResult
  const record = showQueryResult?.data

  //   console.log({ record })
  return (
    <List
      pageHeaderProps={{
        extra: [
          //  <ExportButton onClick={triggerExport} loading={isLoading} />,
          <RefreshButton onClick={() => tableQueryResult?.refetch()} />,
          <CreateButton type="primary" icon={<PlusOutlined />} onClick={() => show()} />,
          <Button onClick={triggerExport}>Export</Button>
        ],
      }}
    >
               <Form {...searchFormProps}>
        <Space>
            <Form.Item name="title">
                <Input placeholder="Search by title" allowClear  onChange={(e)=>{
                            if(e.type==='click'){
                              searchFormProps.form?.submit()
                            }}}/>
            </Form.Item>
            <Button icon={<Icons.SearchOutlined/>} onClick={searchFormProps.form?.submit} >Search</Button>
        </Space>
    </Form>
    <Divider/>
      <Table {...tableProps}
       >
        <Table.Column dataIndex="name" title="Name" />
        {/* <Table.Column<IGrade>
            dataIndex="medium_id"
            title="Medium"
            render={(_, record) => record?.medium?.name}
          /> */}

        <Table.Column<IDifficultyLevel> dataIndex="order" title="Order" />

        <Table.Column
          dataIndex="created_at"
          title="Created At"
          render={value => <DateField value={value} format="LLL" />}
          defaultSortOrder={getDefaultSortOrder('created_at', sorter)}
          sorter
        />
        <Table.Column<IDifficultyLevel>
          title="Actions"
          dataIndex="actions"
          render={(_, record) => (
            <Space>
              <EditButton
                size="small"
                type="link"
                icon={null}
                recordItemId={record.id}
                onClick={() => {
                  setShowId(record?.id)
                  editShow(record.id)
                }}
              />
              <DeleteButton
                size="small"
                type="link"
                icon={null}
                recordItemId={record.id}
                //   hidden={hideDeleteButton(record)}
              />
            </Space>
          )}
        />
      </Table>
      <CreateDifficultyLevel modalProps={modalProps} formProps={formProps} />
      <EditDifficultyLevel modalProps={editModalProps} formProps={editFormProps} record={record} />
    </List>
  )
}
